import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ADD_BRAND_PATH } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';

export const useBrandsHeader = () => {
  const navigate = useNavigate();

  const goToAddBrand = useCallback(() => navigate(ADD_BRAND_PATH), [navigate]);

  const {
    userAccessRights: {
      Products: { IsBrandCreate },
    },
  } = useNewUserAccessRights();

  return { goToAddBrand, IsBrandCreate };
};
